module.exports = __webpack_public_path__ + "img/choi.9eaa3ff4.png";